<form class="regulate-from-balance-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'REGULATE_FROM_BALANCE.HEADER' | translate }}</h4>
  @if (dataContext) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block [text]="'REGULATE_FROM_BALANCE.HELP_TEXT.DESCRIPTION' | translate"></app-information-block>
      <div class="regulate-from-balance-form__summary">
        <span>{{ 'INVOICE.REMAINING_AMOUNT' | translate }}: </span>
        <app-money-box [dataContext]="dataContext.invoiceBalance"></app-money-box>
      </div>
      <div class="regulate-from-balance-form__summary">
        <span>{{ 'REGULATE_FROM_BALANCE.BALANCE' | translate }}: </span>
        <app-money-box [dataContext]="dataContext.balance"></app-money-box>
      </div>
    </section>
  }
  <section class="astral-section-surface astral-section-surface--compact">
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <app-money-box [control]="form.controls['amount']"></app-money-box>
      <astral-date-picker [control]="form.controls['accountingDate']"></astral-date-picker>
    </astral-layout-group>
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" [disabled]="working" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
